import { FunctionComponent, useState, useRef } from "react";
import { useDispatch, connect } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import styles from "../AddOrganization/AddOrganization.module.css";
import TextInput from "../../Components/TextInput/InputText";
import DateInput from "../../Components/TextInput/InputDateFirebase";
import { emailValidate, nameValidate, pincodeValidate } from "../../Values/validatorsnew";
import { useLocation } from "react-router-dom";
import { url } from "../../Values/constants";
import { useEffect } from "react";
import {
  countActiveUsersByOrganization,
  editOrganization,
  updateApiDataEditOrg,
  updateApiTokensEditOrg,
  updateContactEditOrg,
  updateTasksEditOrg,
  updateUsersAdminEmailEditOrg,
  updateUsersEditOrg,
} from "../../Services/organizations";
import { themeColors } from "../../Components/theme";
import axios from "axios";
import { showSnackbarAction } from "../../Redux/actions";
import { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { fetchLicensesCost } from "../../Services/resources";
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import DropDownText from "../../Components/DropDownText/DropDownText";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import PhoneNumberWrapper from "../../Components/TextInput/PhoneNumberWrapper";

type props = {
  history: any;
  theme: any;
};

const EditOrganization: FunctionComponent<props> = ({ history, theme }) => {
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const organizationNameRef: any = useRef();
  const emailRef: any = useRef();
  const addressRef: any = useRef();
  const adminFirstNameRef: any = useRef();
  const adminLastNameRef: any = useRef();
  const adminEmailRef: any = useRef();
  const pincodeRef: any = useRef();
  const employeesRef: any = useRef();
  const passwordRef: any = useRef("");
  const licensesCostRef: any = useRef();
  const location: any = useLocation();
  const [load, setLoad] = useState(false);
  const [countryList, setCountryList] = useState<any>([]);
  const [statesList, setStatesList] = useState<any>([]);
  const [citiesList, setCitiesList] = useState<any>([]);
  const [costLicensesData, setCostLicensesData] = useState<any[] | undefined>(undefined);
  const [activeUserCount, setActiveUserCount] = useState<any>();
  const [noEmp, setNoEmp] = useState<any>("");
  const [tillDate, setTillDate] = useState<any>(null);
  const [tillDateDisplay, setTillDateDisplay] = useState("");
  const [noEmpError, setNoEmpError] = useState<any>(false);
  const [country, setCountry] = useState<any>({ label: "Select", value: "Select" });
  const [state, setState] = useState<any>({ label: "Select", value: "Select" });
  const [cities, setCities] = useState<any>({ label: "Select", value: "Select" });
  const [phoneCountryCode, setPhoneCountryCode] = useState(`${location.state.detail.admin_contact_code}`);
  const [orgPhoneCountryCode, setOrgPhoneCountryCode] = useState(`${location.state.detail.organization_mobile_code}`);
  const [inputTextPassword, setInputTextPassword] = useState(false);
  const [finalPhoneNumber, setFinalPhoneNumber] = useState(`${location.state.detail.admin_contact_number}`);
  const [orgFinalPhoneNumber, setOrgFinalPhoneNumber] = useState(`${location.state.detail.mobile_number}`);

  const handlePhoneChange = (value: string, country: CountryData) => {

    // Extract the country code and phone number from the input value
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setFinalPhoneNumber(value);
    }
    setPhoneCountryCode(country?.dialCode);
  };

  const handleOrgPhoneChange = (value: string, country: CountryData) => {

    // Extract the country code and phone number from the input value
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setOrgFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setOrgFinalPhoneNumber(value);
    }
    setOrgPhoneCountryCode(country?.dialCode);

  };

  useEffect(() => {
    fetchLicensesCost((data) => setCostLicensesData(data));
    setFinalPhoneNumber(location.state.detail.admin_contact_number);
  }, []);

  useEffect(() => {
    countActiveUsersByOrganization(
      (data) => setActiveUserCount(data),
      location.state.detail.organization_id
    );
  }, [location.state.detail.organization_id]);

  useEffect(() => {
    setNoEmp(costLicensesData?.[0]?.no_employees);
  }, [costLicensesData]);

  const editOrganizationDetails = (e: any) => {
    e.preventDefault();
    let tillDatevalue = false;
    const currentDate = new Date();
    const targetDate = new Date(tillDateDisplay);
    if (currentDate >= targetDate) {
      tillDatevalue = true;
    } else {
      tillDatevalue = false;
    }
    if (country.label === "Select") {
      country.label = location.state.detail.country;
    }
    if (state.label === "Select") {
      state.label = location.state.detail.state;
    }
    if (cities.label === "Select") {
      cities.label = location.state.detail.cities;
    }

    if (organizationNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Organization Name Required!!", "error"));
      return;
    }
    else if (emailRef.current?.value === "") {
      dispatcher(showSnackbarAction("Email Required!!", "error"));
      return;
    } else if (addressRef.current.value === "") {
      dispatcher(showSnackbarAction("Address Required!!", "error"));
      return;
    } else if (Object.keys(country).length === 0) {
      dispatcher(showSnackbarAction("Country Required!!", "error"));
      return;
    } else if (Object.keys(state).length === 0) {
      dispatcher(showSnackbarAction("State Required!!", "error"));
      return;
    } else if (Object.keys(cities).length === 0) {
      dispatcher(showSnackbarAction("City Required!!", "error"));
      return;
    } else if (pincodeRef.current?.value === "") {
      dispatcher(showSnackbarAction("Pincode Required!!", "error"));
      return;
    } else if (adminFirstNameRef.current?.value === "") {
      dispatcher(showSnackbarAction("Admin First Name Required!!", "error"));
      return;
    } else if (adminLastNameRef.current?.value === "") {
      dispatcher(showSnackbarAction("Admin First Last Required!!", "error"));
      return;
    } else if (finalPhoneNumber === "") {
      dispatcher(showSnackbarAction("Mobile Number Required!!", "error"));
      return;
    } else if (orgFinalPhoneNumber === "") {
      dispatcher(showSnackbarAction("Mobile Number Required!!", "error"));
      return;
    } else if (adminEmailRef.current?.value === "") {
      dispatcher(showSnackbarAction("Admin Email Required!!", "error"));
      return;
    } else if (inputTextPassword === true) {
      if (passwordRef.current.value === "") {
        dispatcher(showSnackbarAction("Password is Required!!", "error"));
        return;
      }
    }
    else if (tillDatevalue === true) {
      dispatcher(
        showSnackbarAction(
          "Till date should be later than the current date!!",
          "error"
        )
      );
      return;
    } else if (employeesRef.current.value === "") {
      dispatcher(showSnackbarAction("No of Employees Required!!", "error"));
      return;
    } else if (licensesCostRef.current.value === "") {
      dispatcher(showSnackbarAction("No of Employees Required!!", "error"));
      return;
    }
    if (location.state.detail.admin_email_id != adminEmailRef.current?.value) {
      if (inputTextPassword === false) {
        const isConfirmed = window.confirm(
          "Are you sure you want to change Admin Email Id?"
        );
        if (isConfirmed) {
          setInputTextPassword(true);
        } else {
          adminEmailRef.current.value = location.state.detail.admin_email_id;
        }
      } else {
        setLoad(true);
        updateUserAuth();
        sendResetPasswordEmail();

        //update in apitoken collection
        updateApiTokensEditOrg(
          location.state.detail.organization_id,
          adminEmailRef.current?.value.toLowerCase(),
          adminFirstNameRef.current?.value,
          adminLastNameRef.current?.value,
          orgPhoneCountryCode,
          phoneCountryCode,
          finalPhoneNumber
        );

        //update in users collection
        updateUsersEditOrg(
          location.state.detail.organization_id,
          adminEmailRef.current?.value.toLowerCase(),
          adminFirstNameRef.current?.value,
          adminLastNameRef.current?.value,
          phoneCountryCode,
          finalPhoneNumber,
          employeesRef.current.value,
          licensesCostRef.current.value,
          country.label,
          country.value,
          state.label
        );

        //update in contact collection
        updateContactEditOrg(
          location.state.detail.admin_email_id,
          location.state.detail.organization_id,
          adminEmailRef.current?.value.toLowerCase()
        );

        //update in apidData collection
        updateApiDataEditOrg(
          location.state.detail.admin_email_id,
          location.state.detail.organization_id,
          adminEmailRef.current?.value.toLowerCase()
        );

        //update in Tasks collection
        updateTasksEditOrg(
          location.state.detail.admin_email_id,
          location.state.detail.organization_id,
          adminEmailRef.current?.value.toLowerCase()
        );

        //edit admil email in userscollection
        updateUsersAdminEmailEditOrg(
          location.state.detail.admin_email_id,
          location.state.detail.organization_id,
          adminEmailRef.current?.value.toLowerCase()
        );

        const inputDate = new Date(tillDateDisplay);

        editOrganization(
          location.state.detail.organization_id,
          organizationNameRef.current.value,
          orgPhoneCountryCode,
          orgFinalPhoneNumber,
          emailRef.current.value,
          addressRef.current.value,
          country.label,
          country.value,
          state.label,
          state.value,
          cities.label,
          cities.value,
          pincodeRef.current.value,
          adminFirstNameRef.current?.value,
          adminLastNameRef.current?.value,
          phoneCountryCode,
          finalPhoneNumber,
          adminEmailRef.current?.value,
          employeesRef.current.value,
          licensesCostRef.current.value,
          location.state.detail.auth_id,
          history,
          dispatcher,
          (data) => setLoad(data),
          inputDate
        );
        setInputTextPassword(false);
      }
    }
    else {
     
      setLoad(true);
     
      updateUsersEditOrg(
        location.state.detail.organization_id,
        adminEmailRef.current?.value.toLowerCase(),
        adminFirstNameRef.current?.value,
        adminLastNameRef.current?.value,
        phoneCountryCode,
        finalPhoneNumber,
        employeesRef.current.value,
        licensesCostRef.current.value,
        country.label,
        country.value,
        state.label
      );
      
      const inputDate = new Date(tillDateDisplay);

      editOrganization(
        location.state.detail.organization_id,
        organizationNameRef.current.value,
        orgPhoneCountryCode,
        orgFinalPhoneNumber,
        emailRef.current.value,
        addressRef.current.value,
        country.label,
        country.value,
        state.label,
        state.value,
        cities.label,
        cities.value,
        pincodeRef.current.value,
        adminFirstNameRef.current?.value,
        adminLastNameRef.current?.value,
        phoneCountryCode,
        finalPhoneNumber,
        adminEmailRef.current?.value,
        employeesRef.current.value,
        licensesCostRef.current.value,
        location.state.detail.auth_id,
        history,
        dispatcher,
        (data) => setLoad(data),
        inputDate
      );
    }
  };

  const sendResetPasswordEmail = async () => {
    let email = adminEmailRef.current?.value.toLowerCase();
    let firstName = adminFirstNameRef.current?.value;
    let lastName = adminLastNameRef.current?.value;
    if (email !== "") {
      try {
        if (email) {
          setLoad(true);
          const resetPasswordEmailApiData = {
            template_name: "Password_Reset_Notification",
            replaceable_params: [
              { "%#username#%": `${firstName} ${lastName}` },
              { "%#password#%": passwordRef.current?.value },
            ],
            email: email,
          };
          await axios.post(url + "/email/sendEmail", resetPasswordEmailApiData);
          setLoad(false);
          dispatcher(
            showSnackbarAction(
              "Password change information have been sent on you registered email id",
              "success"
            )
          );
          history.push("/");
        }
      } catch (error) {
        console.log("reset error", error);
      }
    } else {
      dispatcher(showSnackbarAction("Please Enter Your Email!", "error"));
    }
  };

  const updateUserAuth = async () => {
    const bodyData = {
      uid: location?.state?.detail?.auth_id,
      newEmail: adminEmailRef.current?.value,
      newPassword: passwordRef.current?.value,
    };
    try {
      const repUpdateUserAuth = await axios.post(
        `${url}/utils/firebase-updateUser`,
        bodyData
      );
      
      // handle response
      console.log("repUpdateUserAuth", repUpdateUserAuth);

    } catch (error) {
      // handle error
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countryRes = await axios.post(`${url}/country/countries`);
        // handle response
        setCountryList(countryRes.data);
      } catch (error) {
        // handle error
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (Object.keys(country).length !== 0) {
      const fetchData = async () => {
        try {
          const statesRes = await axios.post(`${url}/country/states`, {
            iso3: (country as any).value,
          });
          setStatesList(statesRes.data);
        } catch (error) {
          // handle error
        }
      };
      fetchData();
    }
  }, [country]);

  useEffect(() => {
    if (location.state.detail.country_code) {
      const fetchData = async () => {
        try {
          const statesRes = await axios.post(`${url}/country/states`, {
            iso3: location.state.detail.country_code,
          });
          setStatesList(statesRes.data);
        } catch (error) {
          // handle error
        }
      };
      fetchData();
    }
  }, [location.state.detail.country_code]);

  useEffect(() => {
    if (location.state.detail.state_code) {
      const fetchData = async () => {
        try {
          const citiesRes = await axios.post(`${url}/country/cities`, {
            iso3: location.state.detail.state_code,
          });
          // handle response
          setCitiesList(citiesRes.data);
        } catch (error) {
          // handle error
        }
      };
      fetchData();
    }
  }, [location.state.detail.state_code]);

  useEffect(() => {
    if (Object.keys(country).length !== 0 && Object.keys(state).length !== 0) {
      const fetchData = async () => {
        try {
          const citiesRes = await axios.post(`${url}/country/cities`, {
            iso3: (country as any).value,
            state_code: (state as any).value,
          });
          // handle response
          setCitiesList(citiesRes.data);
        } catch (error) {
          // handle error
        }
      };
      fetchData();
    }
  }, [country, state]);

  useEffect(() => {
    setCountry({
      label: location.state.detail.country,
      value: location.state.detail.country_code,
    });
    setState({
      label: location.state.detail.state,
      value: location.state.detail.state_code,
    });
    setCities({
      label: location.state.detail.city,
      value: location.state.detail.city,
    });
  }, [countryList]);

  const choice = () => {
    let optionArr = statesList?.map((list: { state_code: any; name: any }) => ({
      value: list.state_code,
      label: list.name,
    }));
    return optionArr;
  };

  const countryChoice = () => {
    let optionArr = countryList?.map(
      (list: { iso3: any; name: any; phone_code: any }) => ({
        value: list.iso3,
        label: `${list.name}`,
      })
    );
    return optionArr;
  };

  const citiesChoice = () => {
    let optionArr = citiesList?.map((list: { name: any }) => ({
      value: list.name,
      label: list.name,
    }));
    return optionArr;
  };

  const noValidateCost = (LCost: string) => {
    const re = /^[0-9]*$/;
    const valid = re.test(LCost);
    if (valid) {
      setNoEmpError(false);
      return "";
    } else {
      return "Allow only Number.";
    }
  };

  const noValidateEmp = (empNo: any) => {
    const re = /^[0-9]*$/;
    const valid = re.test(empNo);
    if (valid) {
      if (Number(empNo) < activeUserCount) {
        setNoEmpError(true);
        return `The number of employees can't be less than ${activeUserCount}.`;
      } else {
        setNoEmpError(false);
        return "";
      }
    } else {
      setNoEmpError(true);
      return "Allow only Number.";
    }
  };

  const handleCountryChange = (e: any) => {
    const selectedValue = e.target.value;
    const obj = countryList.find((item: any) => item.iso3 === selectedValue);
    const selectedObj = obj
      ? { value: obj.iso3, label: obj.name }
      : { value: "Select", label: "Select" };
    setCountry(selectedObj);
  };

  const handleStateChange = (e: any) => {
    const selectedValue = e.target.value;
    const obj = statesList?.find((item: any) => item?.state_code === selectedValue);
    const selectedObj = obj
      ? { value: obj.state_code, label: obj.name }
      : { value: "Select", label: "Select" };
    setState(selectedObj);
  };

  const handleCitiesChange = (e: any) => {
    const selectedValue = e.target.value;
    const obj = citiesList?.find((item: any) => item?.name === selectedValue);
    const selectedObj = obj
      ? { value: obj.name, label: obj.name }
      : { value: "Select", label: "Select" };
    setCities(selectedObj);
  };

  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  return (
    <>
      <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
        {load && <Loading />}
        <div
          className="d-flex flex-row w-100 px-4 pt-4"
        >
          <span style={{ color: "red", margin: "5px" }}>
            (Note : Password fields will be enabled upon submission after updating
            the admin email.)
          </span>
        </div>
        <div
          className="w-100 d-flex flex-column gap-2 px-4"
          style={{
            padding: isMobile ? '0' : '',
            maxWidth: isMobile ? '100vw' : undefined,
            margin: isMobile ? '0' : '0 auto',
            overflowY: isMobile ? 'auto' : undefined,
            maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
          }}
        >
          <form
            className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
            style={{
              ...cardContainerStyles,
              padding: isMobile ? '16px' : '32px',
              boxSizing: 'border-box',
              minHeight: isMobile ? 'auto' : undefined,
              marginBottom: isMobile ? '50px' : 0,
            }}
          >
            <Grid container spacing={isMobile ? 2 : 3}>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Organization Name"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={organizationNameRef}
                  value={location.state.detail.organization_name}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <PhoneNumberWrapper
                  title="Mobile Number"
                  country={orgPhoneCountryCode}
                  value={`${location.state.detail.organization_mobile_code}+${location.state.detail.mobile_number}`}
                  handlePhoneChange={handleOrgPhoneChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Email"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={emailRef}
                  validator={emailValidate}
                  value={location.state.detail.email_id}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Address"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={addressRef}
                  value={location.state.detail.address}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="Country"
                  options={countryChoice()}
                  value={country.value === "Select" ? "" : country.value}
                  onChange={handleCountryChange}
                  required
                  labelKey="label"
                  valueKey="value"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="State"
                  options={choice()}
                  value={state.value === "Select" ? "" : state.value}
                  onChange={handleStateChange}
                  required
                  labelKey="label"
                  valueKey="value"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="City"
                  options={citiesChoice()}
                  value={cities.value === "Select" ? "" : cities.value}
                  onChange={handleCitiesChange}
                  required
                  labelKey="label"
                  valueKey="value"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Pincode"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={pincodeRef}
                  validator={pincodeValidate}
                  value={location.state.detail.pincode}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Admin First Name"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={adminFirstNameRef}
                  validator={nameValidate}
                  value={location.state.detail.admin_first_name}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Admin Last Name"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={adminLastNameRef}
                  validator={nameValidate}
                  value={location.state.detail.admin_last_name}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <PhoneNumberWrapper
                  title="Admin Contact No"
                  country={phoneCountryCode || 'in'}
                  value={`${location.state.detail.admin_contact_code}+${location.state.detail.admin_contact_number}`}
                  handlePhoneChange={handlePhoneChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Admin Email Id"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={adminEmailRef}
                  validator={emailValidate}
                  value={location.state.detail.admin_email_id}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Number of Employees"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={employeesRef}
                  value={location.state.detail.no_of_employees}
                  validator={noValidateEmp}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Licenses Cost"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={licensesCostRef}
                  value={location.state.detail.cost_per_license}
                  validator={noValidateCost}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Password"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={passwordRef}
                  disabled={!inputTextPassword}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DateInput
                  type="datetime-local"
                  title="Till Date"
                  value={location.state.detail.valid_till}
                  setTillDate={setTillDate}
                  setFormattedTillDate={setTillDateDisplay}
                />
              </Grid>
            
              {/* Remove submit button from inside form for mobile */}
              {!isMobile && (
                <Grid item xs={12} style={{ marginTop: 12 }}>
                  <StyledSubmitButton
                    onClick={(e) => editOrganizationDetails(e)}
                    themeMode={themeMUI.palette.mode}
                    disabled={noEmpError}
                  >
                    {load ? (
                      <span style={{ display: "flex", justifyContent: "center" }}>
                        <Circles color="#fff" height={20} width={20} />
                      </span>
                    ) : (
                      <>Submit</>
                    )}
                  </StyledSubmitButton>
                </Grid>
              )}
            </Grid>
          </form>
        </div>
        {isMobile && (
          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              bgcolor: "white",
              p: 2,
              borderTop: "1px solid #ddd",
              boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
              zIndex: 100,
            }}
          >
            <StyledSubmitButton
              onClick={(e) => editOrganizationDetails(e)}
              themeMode={themeMUI.palette.mode}
              isMobile={isMobile}
              disabled={noEmpError}
            >
              {load ? (
                <span style={{ display: "flex", justifyContent: "center" }}>
                  <Circles color="#fff" height={20} width={20} />
                </span>
              ) : (
                <>Submit</>
              )}
            </StyledSubmitButton>
          </Box>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
  };
};

export default connect(mapStateToProps)(EditOrganization);
